/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { useUpdateEffect } from 'react-use';
import { chevronDown } from '../../assets/images/formAfterSignUp';
import { OptionType } from '../../types';
import styles from './dropdown.module.css';

type TProps = {
  options: OptionType[] | any[];
  label?: string;
  className?: string;
  labelStyles?: string;
  SelectedValueStyles?: string;
  setSelectedOption?: React.Dispatch<React.SetStateAction<OptionType>> | any;
  width?: string;
  borderColor?: string;
  placeholderFont?: string;
  isLoading?: boolean;
  onChange?: (e: any) => void;
  value?: any;
  placeholderColor?: string;
};

function SelectDropDown({
  options,
  className,
  label,
  labelStyles,
  SelectedValueStyles,
  width = 'w-72 sm:w-96',
  borderColor = 'border-[#f8b400]',
  placeholderFont,
  isLoading,
  onChange,
  value,
  placeholderColor,
  setSelectedOption,
}: TProps) {
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    const handler = () => setShowMenu(false);
    window.addEventListener('click', handler);

    return () => {
      window.removeEventListener('click', handler);
    };
  });

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowMenu(!showMenu);
  };

  const [selectedOption, setSelected] = useState<OptionType | null>(value);

  useUpdateEffect(() => {
    onChange?.(selectedOption?.name || selectedOption?.value || selectedOption?.label);
  }, [selectedOption]);
  return (
    <>
      <label className={`${labelStyles}`}>{label}</label>
      <div className={`${[styles.dropdownContainer, width, borderColor].join(' ')}  ${className}`}>
        <div
          className={`${styles.dropdownInput} focus:border-[#f8b400]`}
          onClick={(e) => handleClick(e)}
        >
          <div
            className={`${
              (styles.dropdownSelectedValue, placeholderFont, placeholderColor)
            } ${SelectedValueStyles}`}
          >
            {selectedOption?.value || selectedOption?.label || value}

            {isLoading && 'Loading'}
          </div>
          <div className={styles.dropdownTools}>
            <div className={styles.dropdownIcon}>
              <img src={chevronDown} alt='arrow-down' className='w-3 h-2' />
            </div>
            {showMenu && (
              <div className={styles.dropdownMenu}>
                {options &&
                  options?.map((option, i) => (
                    <div
                      key={i}
                      className={styles.dropdownItem}
                      onClick={() => {
                        setSelected(option);
                        setSelectedOption(option);
                      }}
                    >
                      {option.name || option.label}
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default SelectDropDown;
